/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface InlinePromoUiModuleBody
 */
export interface InlinePromoUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    moduleType: InlinePromoUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof InlinePromoUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof InlinePromoUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof InlinePromoUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof InlinePromoUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof InlinePromoUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    ctaUrlPath: string;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    ctaName: string;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    portraitFillImage: string;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    landscapeFillImage: string;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    mobileFillImage?: string;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    ctvFillImage?: string;
    /**
     * 
     * @type {string}
     * @memberof InlinePromoUiModuleBody
     */
    priceText?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum InlinePromoUiModuleBodyModuleTypeEnum {
    INLINE_PROMO = 'INLINE_PROMO'
}



